<template>
    <div class="mx-1 mt-2">
        <div>
            <!-- Slot Games -->
            <div class="col-12 p-0 py-1">
                <div class="d-flex">
                    <div class="my-auto mr-2">
                        <img
                            src="https://hj-hashgo.s3.ap-southeast-1.amazonaws.com/80001001/zh-CN/factory_channel_category/hot-1.png?t=11/4/2025"
                            style="width: 1.5rem"
                        />
                    </div>
                    <div>
                        <h4
                            class="text-nowrap font-semibold pt-1"
                            style="color: white; font-size: 1.3rem !important;"
                        >
                            {{ $t("home.popular_slot_games") }}
                        </h4>
                    </div>
                </div>

                <div class="d-flex flex-wrap">
                    <Swiper
                        :modules="[Autoplay]"
                        :slides-per-view="hotGames['slotGames'].length > 3 ? 3.7 : hotGames['slotGames'].length"
                        :loop="false"
                        :autoplay="{ delay: 3300 }"
                        :pagination="{ clickable: true }"
                        :initial-slide="0"
                        class="responsible-swiper"
                        :looped-slides="3.5"
                    >
                        <SwiperSlide
                            v-for="slotGame in hotGames['slotGames']"
                            :key="slotGame.id"
                        >
                            <GameCard
                                @click="$emit('gameInit', slotGame)"
                                :game="slotGame"
                            />
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>

            <!-- Fishing Games -->
            <div class="col-12 p-0 py-1 -mt-4">
                <div class="d-flex">
                    <div class="my-auto mr-2">
                        <img
                            src="https://hj-hashgo.s3.ap-southeast-1.amazonaws.com/80001001/zh-CN/factory_channel_category/fishing-1.png?t=11/4/2025"
                            style="width: 1.5rem"
                        />
                    </div>

                    <div class="my-auto">
                        <h4
                            class="text-nowrap font-semibold"
                            style="color: white; font-size: 1.3rem !important;"
                        >
                            {{ $t("home.popular_fishing_games") }}
                        </h4>
                    </div>
                </div>

                <div class="d-flex flex-wrap">
                    <Swiper
                        :modules="[Autoplay]"
                        :slides-per-view="hotGames['fishingGames'].length > 3 ? 3.7 : hotGames['fishingGames'].length"
                        :loop="true"
                        :autoplay="{ delay: 3300 }"
                        :pagination="{ clickable: true }"
                        :initial-slide="0"
                        class="responsible-swiper"
                        :looped-slides="3"
                    >
                        <SwiperSlide
                            v-for="fishingGame in hotGames['fishingGames']"
                            :key="fishingGame.id"
                        >
                            <GameCard
                                @click="$emit('gameInit', fishingGame)"
                                :game="fishingGame"
                            />
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>

            <!-- Arcade Games -->
            <div class="col-12 p-0 py-1 -mt-4">
                <div class="d-flex">
                    <div class="my-auto mr-2">
                        <img
                            src="https://hj-hashgo.s3.ap-southeast-1.amazonaws.com/80001001/zh-CN/factory_channel_category/card-1.png?t=11/4/2025"
                            style="width: 1.5rem"
                        />
                    </div>

                    <div class="my-auto">
                        <h4
                            class="text-nowrap font-semibold pt-0"
                            style="color: white; font-size: 1.3rem !important;"
                        >
                            {{ $t("home.popular_arcade_games") }}
                        </h4>
                    </div>
                </div>

                <div class="d-flex flex-wrap">
                    <Swiper
                        :modules="[Autoplay]"
                        :slides-per-view="hotGames['arcadeGames'].length > 3 ? 3.7 : hotGames['arcadeGames'].length"
                        :loop="true"
                        :autoplay="{ delay: 3300 }"
                        :pagination="{ clickable: true }"
                        :initial-slide="0"
                        class="responsible-swiper"
                        :looped-slides="3"
                    >
                        <SwiperSlide
                            v-for="arcadeGame in hotGames['arcadeGames']"
                            :key="arcadeGame.id"
                        >
                            <GameCard
                                @click="$emit('gameInit', arcadeGame)"
                                :game="arcadeGame"
                            />
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Autoplay } from "swiper/modules";

export default {
    props: {
        hotGames: {
            type: Object,
            required: true,
            default: () => ({
                slotGames: [],
                fishingGames: [],
                arcadeGames: [],
            }),
        },
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    methods: {
    },
};
</script>
